import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
/** import mui components in the section above, keep the ascending order */

import Spacer from 'widgets-v5/spacer';
/** import widgets components in the section above, keep the ascending order */

const InfoAlertOverviewPage = () => {
    return (
        <React.Fragment>
            <Spacer />
            <Grid>
                <Box display="flex" justifyContent="flex-start" marginLeft="16px">
                    <Alert severity="info" sx={{ maxWidth: 'fit-content' }}>
                        This page is read-only for Programmatic Guaranteed campaigns. To make
                        changes to ads in this campaign, please use the ADS tab.
                    </Alert>
                </Box>
            </Grid>
        </React.Fragment>
    );
};

export default InfoAlertOverviewPage;
